export default __webpack_public_path__ + "static/media/segre07.6aec2018.jpg";